import http from "./httpService";

const apiEndPoint = "/locations/list_remotecmd";

async function getCommands(serverType = null) {
  const params = {};
  if (serverType) {
    params.server_type = serverType;
  }

  const response = await http.get(apiEndPoint, { params });
  const adaptedCommands = [];
  response.data.commands.forEach((command, index) => {
    adaptedCommands[index] = {
      id: index,
      value: index,
      label: command,
    };
  });

  return adaptedCommands;
}

export default getCommands;
